import AbstractSystem from "../all/AbstractSystem";

class NagraSystem extends AbstractSystem {

    getDisplayResolution() {
        return {
            width: (window.innerWidth !== null ? window.innerWidth : document.body !== null ? document.body.clientWidth : null),
            height: (window.innerHeight !== null ? window.innerHeight : document.body !== null ? document.body.clientHeight : null)
        };
    }

    exit() {
        window.open('/node/homeuser', '_self', '');
        window.close();
    }
}

export default NagraSystem;



// WEBPACK FOOTER //
// ./src/devices/nagra/System.js